<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ryGSnV/tc-custom/9781480429772.jpg?1706787780573" alt="This image is the cover for the book Speak to Me of Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Speak to Me of Love
      </h1>
      <p class="bookDescription body article font2">
        <b>In her “best novel,” the <i>New York Times</i>–bestselling author follows the love life of a British department store heiress from the 1880s through World War I (<i>Publishers Weekly</i>).</b><br/><br/> The plump, plain daughter of a successful shopkeeper, Beatrice Bonnington has no illusions about her looks—or her marital prospects. So when she receives a proposal from the dashing William Overton—a man she’s secretly desired for years—Beatrice can’t believe her good fortune.  Knowing her husband will never wholly belong to her, she turns her energies to the other great passion of her life: her family’s department store. As she endures tragedy, betrayal, and the horrors of war, she builds Bonnington’s Emporium into a titan of commerce that rivals London’s Selfridge’s. But with all of her worldly success, she never stops loving William. One more challenge awaits Beatrice—the battle for her husband’s heart. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Eden
      </h2>
      
      <p class="authorDescription body article">Dorothy Eden (1912&ndash;1982) was the internationally acclaimed author of more than forty bestselling Gothic, romantic suspense, and historical novels. Born in New Zealand, where she attended school and worked as a legal secretary, she moved to London in 1954 and continued to write prolifically. Eden&rsquo;s novels are known for their suspenseful, spellbinding plots, finely drawn characters, authentic historical detail, and often a hint of spookiness.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?542cde82